import * as React from 'react'
import { createBrowserRouter, Navigate } from 'react-router-dom'

import PrivateRoute from './PrivateRoute'
import PublicRoute from './PublicRoute'
import RootLayout from 'layout/RootLayout'
import EventLayout from 'layout/EventLayout'
import Login from 'pages/Login'
import ScannerHome from 'pages/ScannerHome'
import ScanCamera from 'pages/ScanCamera'
import ScanResult from 'pages/ScanResult'
import CreateOrder from 'pages/CreateOrder'
import Report from 'pages/Report'
import AddCoupon from 'pages/AddCoupon'
import CouponList from 'pages/CouponList'
import DetailReport from 'pages/DetailReport'
import EventListing from 'pages/EventListing'
import RegisteredUsers from 'pages/RegisteredUsers'
import MoreMenu from 'pages/MoreMenu'
import StaffList from 'pages/StaffList'
import StaffForm from 'pages/StaffForm'
import NoFound from 'pages/NoFound'
import { authLoader } from 'shared/util/authLoader'

export const router = createBrowserRouter([
  {
    path: '/login',
    element: (
      <PublicRoute>
        <Login />
      </PublicRoute>
    )
  },
  {
    path: '/',
    element: <RootLayout />,
    children: [
      {
        path: '',
        element: <PrivateRoute />,
        loader: authLoader,
        children: [{ path: '', element: <EventListing /> }]
      }
    ]
  },
  {
    path: '/events/:eventId',
    element: <PrivateRoute />,
    loader: authLoader,
    children: [
      {
        path: '',
        element: <EventLayout />,
        children: [
          { path: '', element: <ScannerHome /> },
          { path: 'scan', element: <ScanCamera /> },
          { path: 'result', element: <ScanResult /> },
          { path: 'reports', element: <Report /> },
          { path: 'sales', element: <DetailReport /> },
          { path: 'users', element: <RegisteredUsers /> },
          { path: 'coupons', element: <CouponList /> },
          { path: 'coupons/new', element: <AddCoupon /> },
          { path: 'coupons/:couponId', element: <AddCoupon /> },
          { path: 'order', element: <CreateOrder /> },
          { path: 'more', element: <MoreMenu /> }
        ]
      }
    ]
  },
  {
    path: '/staff',
    element: <PrivateRoute />,
    loader: authLoader,
    children: [
      { path: '', element: <StaffList /> },
      { path: 'new', element: <StaffForm /> },
      { path: ':staffId', element: <StaffForm /> }
    ]
  },
  {
    path: 'scanner',
    element: <Navigate to="/" replace />
  },
  {
    path: 'invalidpage',
    element: <NoFound />
  },
  {
    path: '*',
    element: <NoFound />
  }
])
